import React from "react";
import {
  View,
  Modal as RNModal,
  ViewStyle,
  StyleSheet,
  TouchableWithoutFeedback,
} from "react-native";

interface ModalProps {
  onClose?: () => void;
  animationType?: "none" | "slide" | "fade";
  backgroundColor?: string;
  style?: ViewStyle | ViewStyle[];
}

const Modal: React.FC<ModalProps> = ({
  children,
  onClose,
  animationType = "fade",
  backgroundColor = "transparent",
  style,
}) => {
  return (
    <RNModal
      visible={true}
      transparent={true}
      onDismiss={onClose}
      animationType={animationType}
    >
      <TouchableWithoutFeedback onPress={onClose}>
        <View
          style={[
            styles.overlay,
            {
              backgroundColor,
            },
            style,
          ]}
        >
          <TouchableWithoutFeedback>
            {typeof children === "function" ? children(onClose) : children}
          </TouchableWithoutFeedback>
        </View>
      </TouchableWithoutFeedback>
    </RNModal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flex: 1,
    justifyContent: "center",
    zIndex: 100,
  },
});

export default Modal;
